// extracted by mini-css-extract-plugin
export default {"c":"flip-card_c__zw9-f","front":"flip-card_front__GFgCm","back":"flip-card_back__KqbjI","container":"flip-card_container__IoVdb"};